import React from 'react'
import AdvancedSearch from '../advanced-search'

const AdvancedSearchEn = () => {
    return <AdvancedSearch languageCode="en" />
}

export default AdvancedSearchEn
